import React from 'react';
import fr from 'facet-rest';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const LogDifferencesWrapper = ({ resource }) => {
  return (
    <IncludedRelationshipProvider
      relationship={resource.relationship(fr.relationships.differences.name)}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

LogDifferencesWrapper.propTypes = {
  resource: PropTypes.object.isRequired,
};


export default LogDifferencesWrapper;
